import { PhaseItemStatus } from '../../Entity'
import { getDocFlowPhases } from '../DocFlow.utils.phases'

export function getDocFlowPhaseStatusText(status) {
  switch (status) {
    case PhaseItemStatus.finished:
      return 'DocumentStapling.PhaseFinishedKey'
    case PhaseItemStatus.inProgress:
      return 'DocumentStapling.PhaseInProgressKey'
    case PhaseItemStatus.notStarted:
      return 'DocumentStapling.PhaseNotStartedKey'

    default:
      return null
  }
}

export function getDocFlowPhaseTooltipAdditionalText({ selected, status }) {
  if (
    (status === PhaseItemStatus.finished ||
      status === PhaseItemStatus.inProgress) &&
    !selected
  ) {
    return 'DocumentStapling.ClickToMovePhaseTooltipAdditionalInfoKey'
  }

  if (
    (status === PhaseItemStatus.finished ||
      status === PhaseItemStatus.inProgress) &&
    selected
  ) {
    return 'DocumentStapling.ActivePhaseTooltipAdditionalInfoKey'
  }

  if (PhaseItemStatus.notStarted) {
    return 'DocumentStapling.NotStartedPhaseTooltipAdditionalInfoKey'
  }
}

export function isDisabledDocFlowPhase(item) {
  return item.status === PhaseItemStatus.notStarted
}

export function getPreparedPhases(value, t) {
  return getDocFlowPhases(t).map(item => {
    if (item.id === value) {
      item.status = PhaseItemStatus.inProgress
    }

    if (item.id < value) {
      item.status = PhaseItemStatus.finished
    }

    if (item.id > value) {
      item.status = PhaseItemStatus.notStarted
    }

    return item
  })
}
